module.exports = __webpack_public_path__ + "static/img/1.844e2c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news25/1.jpg
// module id = Epmz
// module chunks = 1